import React, { useState, useRef, useEffect } from 'react';
import { FaChevronDown, FaSearch } from 'react-icons/fa';

import { useTranslation } from "react-i18next";

const DropDown = ({ options, selectedValue, onChange, readOnly, error, opened = false }) => {

    const [isOpen, setIsOpen] = useState(opened);
    const [labelValue, setLabelValue] = useState(selectedValue ? selectedValue.label : null);
    const [searchTerm, setSearchTerm] = useState(""); // Nuevo estado para manejar el término de búsqueda
    const [t] = useTranslation("customDropdown")



    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (!opened) {
            document.addEventListener('click', handleClickOutside);
            return () => {
                document.removeEventListener('click', handleClickOutside);
            };
        }

    }, []);

    useEffect(() => {
        setIsOpen(opened);

    }, [opened]);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    }

    const handleDivClick = (data) => {
        setIsOpen(false);
        if (onChange) {
            onChange(data);
        }
        setLabelValue(data.label)
    }

    useEffect(() => {
        if (readOnly && !selectedValue && labelValue !== null) {

            handleDivClick('')
        }
    }, [selectedValue]);

    // Filtrar las opciones basadas en el término de búsqueda
    const filteredOptions = options.filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase()));
    return (
        <div className={`${opened ? 'custom-dropdown-opened' : `custom-dropdown w-100 ${error ? 'custom-dropdown-error' : 'custom-ellipsis'}`}`} ref={ref} onClick={!readOnly && !opened ? toggleDropdown : null} style={{ zIndex: isOpen ? 100 : 1 }}>

            {!opened &&
                <div className={`custom-ellipsis`}>
                    {readOnly ? '' : (labelValue === null || labelValue === undefined ? selectedValue ? selectedValue.label : '' : labelValue)}
                </div>
            }
            <FaChevronDown
                className={
                    `${opened
                        ? 'd-none'
                        : `custom-dropdown-chevron ${error ? 'custom-dropdown-chevron-error' : ''}`
                    }`}
                size={12}
            />
            {isOpen && (
                <div className={`dropdown-options-container custom-shadow-bold rounded-border-px ${opened && 'new-tab-dropdown-container'}`}>
                    {options.length > 8 && (
                        <div className="dropdown-options custom-dropdown-search-container custom-shadow-bold"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <input
                                type="text"
                                placeholder={t("searchBox.search")}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                onClick={(e) => e.stopPropagation()}
                                className="custom-dropdown-search"
                            />
                            <div className='custom-dropdown-search-icon-container custom-shadow-bold'>
                                <FaSearch size={18} className='custom-dropdown-search-icon' onClick={(e) => e.stopPropagation()}
                                />

                            </div>
                        </div>
                    )}


                    {filteredOptions.map((option, index) => (
                        <div
                            key={index}
                            className={`dropdown-options ${labelValue !== null && labelValue === option.label ? 'dropdown-options-selected' : ''} custom-shadow-bold`}
                            onClick={() => handleDivClick(option)}
                            tabIndex={0}
                            role="button"
                            onKeyDown={(e) => e.key === 'Enter' && handleDivClick(option)}
                        >
                            {option.label}
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default DropDown;
